export const GET_CASESTUDY= 'GET_CASESTUDY';
export const GET_CASESTUDY_ERR = 'GET_CASESTUDY_ERR';

export const GET_ALLCASESTUDY= 'GET_ALLCASESTUDY';
export const GET_ALLCASESTUDY_ERR = 'GET_ALLCASESTUDY_ERR';

export const GET_CASESTUDY_CATEGORIES= 'GET_CASESTUDY_CATEGORIES';
export const GET_CASESTUDY_CATEGORIES_ERR = 'GET_CASESTUDY_CATEGORIES_ERR';
